$(document).on('_page_ready', function () {
    var anchors = $("#accessi").find("a");
    anchors.each(function () {
        var $this = $(this);
        $this.attr('href', window.location.origin + window.location.pathname + window.location.search + $this.attr("href"));
    });
});